import React from "react";
import CardView from "./CardView";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";

interface IProps
{
    routeChoiceList: RouteChoice[];
    useID?:string
    isSlick?:boolean
    desktopCols?:number
    removeData?:boolean
    rotateColours?:boolean
    margin?:string
}
const CardDeckView = (props: IProps) =>
{
    const desktopCols = props.desktopCols ?? 2;
    const slickCards:string = (desktopCols == 3) ? 'slick-cards3' :  'slick-cards';

    const margin = props.margin ?? "my-4";
    const rowData = props.isSlick ? slickCards : (' d-flex align-items-stretch row-cols-1 row-cols-md-2 row-cols-lg-' + desktopCols + ' g-4 '+margin);
    const useID = props.useID ? props.useID : ('cardDownloadDeck-' + Math.random());
    return <>
        <div className={"row "+rowData} id={useID}>


            {props.routeChoiceList.map((routeChoice, index) =>
            {
                const postChoice = routeChoice.postDataChoice ?? null;

                return <div
                    className="col"
                    id={!props.removeData ? "card-"+postChoice?.slug : undefined}
                    data-category={!props.removeData ? postChoice?.categoriesListed.split(" ").join("") : undefined}
                    data-post-id={!props.removeData ? postChoice?.postID : undefined}
                    data-sibling-card={!props.removeData ? "map-marker-"+postChoice?.slug  : undefined}
                    data-lat={!props.removeData ? postChoice?.lngLat?.lat : undefined}
                    data-lng={!props.removeData ? postChoice?.lngLat?.lng : undefined}
                    key={index}
                >
                    <CardView
                        routeChoice={routeChoice}
                    />
                </div>;
            })}

        </div>
    </>
}
export default CardDeckView;